import { useEffect, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

export const BorrowerPicker = ({ value, onChange, invalid }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/borrowers", { params: { search: q, page_size: 25 } }).then((r) => setItems(r.data.items));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    if (value && (!selected || selected.id !== value)) api.get(`/borrowers/${value}`).then((r) => setSelected(r.data)).catch(() => {});
  }, [value, selected]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" type="button" data-testid="loan-borrower-select"
          className={cn("h-11 w-full justify-between bg-card font-normal", invalid && "border-destructive")}>
          {selected ? <span>{selected.name} <span className="text-muted-foreground">· {selected.email}</span></span> : <span className="text-muted-foreground">Select borrower…</span>}
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Search by name or email" value={q} onValueChange={setQ} data-testid="loan-borrower-search" />
          <CommandList>
            <CommandEmpty>No borrowers found.</CommandEmpty>
            {items.map((b) => (
              <CommandItem key={b.id} value={b.id} data-testid={`borrower-option-${b.email}`}
                onSelect={() => { setSelected(b); onChange(b.id); setOpen(false); }}>
                <Check className={cn("mr-2 h-4 w-4", value === b.id ? "opacity-100" : "opacity-0")} />
                <div>
                  <div className="text-sm">{b.name}</div>
                  <div className="text-xs text-muted-foreground">{b.email}</div>
                </div>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
